var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15, _g, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTinnedfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tinned-food",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.221,
    height: 53.5,
    viewBox: "0 0 34.221 53.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10917",
    "data-name": "Path 10917",
    d: "M126.472,3.6c0-1.989-7.661-3.6-17.111-3.6S92.251,1.612,92.251,3.6s7.661,4.809,17.111,4.809S126.472,5.59,126.472,3.6Z",
    transform: "translate(-92.251)",
    fill: "#afaab4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10918",
    "data-name": "Path 10918",
    d: "M127.993,38.182A44.344,44.344,0,0,0,142.93,35.5c-2.929-1.1-8.52-1.843-14.936-1.843s-12.008.743-14.936,1.843A44.344,44.344,0,0,0,127.993,38.182Z",
    transform: "translate(-110.883 -30.136)",
    fill: "#a298a5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10919",
    "data-name": "Path 10919",
    d: "M111.256,63.868c-8.511,0-15.571-1.3-16.89-3.009v40.6c1.318,1.713,8.378,3.021,16.89,3.021s15.571-1.308,16.89-3.021v-40.6C126.827,62.572,119.767,63.868,111.256,63.868Z",
    transform: "translate(-94.145 -54.5)",
    fill: "#ffc250"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10920",
    "data-name": "Path 10920",
    d: "M123.839,70.659V96.937a13.24,13.24,0,0,1-12.507,13.219c-1.4.078-2.868.119-4.383.119a59.93,59.93,0,0,1-12.584-1.161v.293c1.318,1.713,8.378,4.6,16.89,4.6s15.571-2.887,16.89-4.6V69.731C127.6,70.442,126.06,70.152,123.839,70.659Z",
    transform: "translate(-94.145 -62.445)",
    fill: "#ebb044"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10921",
    "data-name": "Path 10921",
    d: "M274.662,342.618a3.141,3.141,0,0,1,1.085-5.149,6.715,6.715,0,0,0,3.831-3.831,3.141,3.141,0,0,1,5.149-1.085,4.642,4.642,0,0,1,1.045,4.962,10.775,10.775,0,0,1-6.147,6.147A4.642,4.642,0,0,1,274.662,342.618Z",
    transform: "translate(-254.777 -296.98)",
    fill: "#95d6a4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10922",
    "data-name": "Path 10922",
    d: "M274.662,342.618a3.141,3.141,0,0,1,1.085-5.149,6.715,6.715,0,0,0,3.831-3.831,3.141,3.141,0,0,1,5.149-1.085,4.642,4.642,0,0,1,1.045,4.962,10.775,10.775,0,0,1-6.147,6.147A4.642,4.642,0,0,1,274.662,342.618Z",
    transform: "translate(-254.777 -296.98)",
    fill: "#dd636e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10923",
    "data-name": "Path 10923",
    d: "M306.693,338.053a13.246,13.246,0,0,1-8.108,11.386,4.641,4.641,0,0,0,3.287-.027,10.775,10.775,0,0,0,6.147-6.147,4.642,4.642,0,0,0-1.045-4.962A3.225,3.225,0,0,0,306.693,338.053Z",
    transform: "translate(-277.025 -302.729)",
    fill: "#da4a54"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10924",
    "data-name": "Path 10924",
    d: "M129.645,340.109a2.619,2.619,0,0,0-.9-4.293,5.6,5.6,0,0,1-3.194-3.194,2.619,2.619,0,0,0-4.293-.9,3.871,3.871,0,0,0-.871,4.137,8.985,8.985,0,0,0,5.126,5.126,3.87,3.87,0,0,0,4.137-.871Z",
    transform: "translate(-117.208 -296.368)",
    fill: "#95d6a4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10925",
    "data-name": "Path 10925",
    d: "M129.645,340.109a2.619,2.619,0,0,0-.9-4.293,5.6,5.6,0,0,1-3.194-3.194,2.619,2.619,0,0,0-4.293-.9,3.871,3.871,0,0,0-.871,4.137,8.985,8.985,0,0,0,5.126,5.126,3.87,3.87,0,0,0,4.137-.871Z",
    transform: "translate(-117.208 -296.368)",
    fill: "#dd636e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10926",
    "data-name": "Path 10926",
    d: "M308.856,163.429a2.68,2.68,0,0,0,.243-4.483,5.729,5.729,0,0,1-2.311-4,2.679,2.679,0,0,0-4-2.031,3.961,3.961,0,0,0-1.957,3.858,9.194,9.194,0,0,0,3.709,6.424A3.961,3.961,0,0,0,308.856,163.429Z",
    transform: "translate(-279.012 -136.61)",
    fill: "#95d6a4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10927",
    "data-name": "Path 10927",
    d: "M308.856,163.429a2.68,2.68,0,0,0,.243-4.483,5.729,5.729,0,0,1-2.311-4,2.679,2.679,0,0,0-4-2.031,3.961,3.961,0,0,0-1.957,3.858,9.194,9.194,0,0,0,3.709,6.424A3.961,3.961,0,0,0,308.856,163.429Z",
    transform: "translate(-279.012 -136.61)",
    fill: "#dd636e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10928",
    "data-name": "Path 10928",
    d: "M376.427,215.62q.076-.039.15-.082a2.679,2.679,0,0,0,.243-4.483q-.2-.149-.393-.315Z",
    transform: "translate(-346.733 -188.719)",
    fill: "#da4a54"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10929",
    "data-name": "Path 10929",
    d: "M229.932,285.919a2.274,2.274,0,0,1-.206-3.8,4.862,4.862,0,0,0,1.961-3.4,2.274,2.274,0,0,1,3.4-1.723,3.361,3.361,0,0,1,1.661,3.274,7.8,7.8,0,0,1-3.148,5.452,3.361,3.361,0,0,1-3.666.2Z",
    transform: "translate(-214.527 -247.776)",
    fill: "#95d6a4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10930",
    "data-name": "Path 10930",
    d: "M229.932,285.919a2.274,2.274,0,0,1-.206-3.8,4.862,4.862,0,0,0,1.961-3.4,2.274,2.274,0,0,1,3.4-1.723,3.361,3.361,0,0,1,1.661,3.274,7.8,7.8,0,0,1-3.148,5.452,3.361,3.361,0,0,1-3.666.2Z",
    transform: "translate(-214.527 -247.776)",
    fill: "#dd636e"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 7.926,
    cy: 7.926,
    rx: 7.926,
    ry: 7.926,
    transform: "translate(2.912 13.166)",
    fill: "#f1f1f4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10931",
    "data-name": "Path 10931",
    d: "M149.817,126.9a7.926,7.926,0,0,1-5.529,13.606,7.984,7.984,0,0,1-1.223-.094,7.927,7.927,0,1,0,6.752-13.512Z",
    transform: "translate(-137.755 -113.642)",
    fill: "#dfdde2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9209",
    "data-name": "Group 9209",
    transform: "translate(5.431 19.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10932",
    "data-name": "Path 10932",
    d: "M314.575,377.528a.807.807,0,0,1-.42-1.5,9.4,9.4,0,0,0,3.1-3.073.807.807,0,1,1,1.373.85,11.017,11.017,0,0,1-3.633,3.6A.8.8,0,0,1,314.575,377.528Z",
    transform: "translate(-296.05 -353.151)",
    fill: "#da4a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10933",
    "data-name": "Path 10933",
    d: "M147.836,368.2a.8.8,0,0,1-.418-.117,9.321,9.321,0,0,1-3.074-3.049.807.807,0,1,1,1.373-.85,7.7,7.7,0,0,0,2.539,2.518.807.807,0,0,1-.42,1.5Z",
    transform: "translate(-144.223 -345.296)",
    fill: "#da4a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10934",
    "data-name": "Path 10934",
    d: "M326.806,191.8a.805.805,0,0,1-.584-.249,9.521,9.521,0,0,1-2.226-3.82.807.807,0,0,1,1.546-.465,7.9,7.9,0,0,0,1.847,3.169.807.807,0,0,1-.583,1.365Z",
    transform: "translate(-305.18 -186.687)",
    fill: "#da4a54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10935",
    "data-name": "Path 10935",
    d: "M255.4,309.07a.807.807,0,0,1-.583-1.365,6.582,6.582,0,0,0,1.539-2.64.807.807,0,0,1,1.546.465,8.2,8.2,0,0,1-1.918,3.291A.8.8,0,0,1,255.4,309.07Z",
    transform: "translate(-243.06 -292.179)",
    fill: "#da4a54"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10936",
    "data-name": "Path 10936",
    d: "M176.406,180.3h-3.343a.807.807,0,0,1,0-1.615h3.343a.807.807,0,0,1,0,1.615Z",
    transform: "translate(-163.896 -160.012)",
    fill: "#756e78"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10937",
    "data-name": "Path 10937",
    d: "M158.4,211.2h-8.1a.807.807,0,0,1,0-1.615h8.1a.807.807,0,1,1,0,1.615Z",
    transform: "translate(-143.509 -187.688)",
    fill: "#756e78"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10938",
    "data-name": "Path 10938",
    d: "M218.606,209.588h-1a7.913,7.913,0,0,1-.881,1.615h1.882a.807.807,0,0,0,0-1.615Z",
    transform: "translate(-203.717 -187.688)",
    fill: "#665e66"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10939",
    "data-name": "Path 10939",
    d: "M126.472,37.982c0,1.989-7.661,3.6-17.111,3.6s-17.111-1.612-17.111-3.6V34.466c0,1.989,7.661,3.6,17.111,3.6s17.111-1.612,17.111-3.6Z",
    transform: "translate(-92.251 -30.865)",
    fill: "#c6c1c8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10940",
    "data-name": "Path 10940",
    d: "M126.472,451.887c0,1.989-7.661,3.6-17.111,3.6s-17.111-1.612-17.111-3.6v-2.872a.119.119,0,0,1,.213-.074c1.3,1.718,8.369,3.031,16.9,3.031s15.6-1.313,16.9-3.031a.119.119,0,0,1,.213.074v2.872Z",
    transform: "translate(-92.251 -401.988)",
    fill: "#c6c1c8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinnedfood);
export default __webpack_public_path__ + "static/media/tinnedfood.cf2cb95e772340078fd38a0d7dd4a8ff.svg";
export { ForwardRef as ReactComponent };